
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.8 22.3l-2.1-2.1c.6-.8 1.1-1.8 1.1-2.9 0-2.6-2.1-4.8-4.8-4.8-2.6 0-4.8 2.1-4.8 4.8S14.4 22 17 22c1.1 0 2.1-.4 2.9-1l2.1 2.1.8-.8zm-9.4-5.1c0-2 1.6-3.6 3.6-3.6s3.6 1.6 3.6 3.6-1.6 3.6-3.6 3.6-3.6-1.6-3.6-3.6z"}}),_c('path',{attrs:{"d":"M17.2 7.8c.1.1.1.1.1.2v2.3h1.2V8c0-.4-.1-.7-.4-1l-5.3-5.1c-.3-.3-.6-.4-1-.4H5.3c-1.1 0-2 .9-2 2v15.7c0 1.1.9 2 2 2h5.2V20H5.3c-.4 0-.8-.3-.8-.8V3.4c0-.4.3-.8.8-.8H12v5.1h5.2z"}})])
          )
        }
      }
    